// ** React Imports
import { Suspense } from 'react'
import { Navigate } from 'react-router-dom'

// ** Utils
import { useSelector } from 'react-redux'

const PublicRoute = ({ children, route }) => {
	const { isSuccess } = useSelector((state) => state.auth.login)

	const currentURL = window.location.pathname

	if (route) {
		if (
			currentURL.startsWith('/verify-resetpassword/') ||
			currentURL.startsWith('/verify-resetemail/') ||
			currentURL.startsWith('/verify-resetphone/') ||
			currentURL.startsWith('/verify-resetsecpassword/') ||
			currentURL.startsWith('/verify-accountinfo/')
		) {
		} else if (isSuccess) {
			return <Navigate to="/account" />
		}
	}

	return <Suspense fallback={null}>{children}</Suspense>
}

export default PublicRoute
